define.alias("shared/components/shared/post/secondary/caption-writer/info-modal", "calendar/components/shared/post/secondary/caption-writer/info-modal");